<mat-form-field>
    <input (blur)="onBlur()" (keydown)="editDate($event)" matInput [matDatepicker]="picker" placeholder="{{placeholder}}"
        [min]="minDate" [max]="maxDate" (dateInput)="onInput($event)" (dateChange)="onChange($event)"   [(ngModel)]="value"
        [disabled]="disabled" [required]="isRequired" (focus)="onFocus(picker)" [matDatepickerFilter]="dateFilter">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker startView="{{startView}}" [startAt]="startDate" touchUi="{{touchUI}}"></mat-datepicker>
    <div class="overlay" (click)="overlayClicked()" *ngIf="datePickerOverlay"></div>
</mat-form-field>

